/**
 * 将棋の駒。 焼いた島黄楊のスプライト + 印刷の漢字。
 *
 * - 駒は**楔形**で、 頭が薄く駒尻が厚い (玉将で 4.2mm 対 9.6mm)。 等厚で作ると平板に見える。
 *   天面と手前の小口をスプライトが持つので、 升に置くと厚みが絵に出る。
 * - **形そのものが向きを持つ**ので、 相手の駒は 180° 回した別スプライトを焼いてある。
 *   要素ごと回すと光まで回ってしまう。 光は盤に固定する (§4)。
 * - 漢字は焼かない。 成駒の赤も含めて情報は CSS 側に置く (§3.6)。
 *   → docs/design/MATERIAL_RENEWAL.md
 */
const KOMA = `${import.meta.env.BASE_URL}generated/shogi/koma.png`;
const KOMA_OPP = `${import.meta.env.BASE_URL}generated/shogi/koma-opp.png`;

interface Props {
  /** 駒に書く字。 成駒でも呼び出し側が決める (「王」/「玉」 の出し分けも含む)。 */
  kanji: string;
  /** viewer から見て敵側 (= 画面上に表示される) の駒。 頂点が下を向く。 */
  flipped?: boolean;
  /** 成駒は赤字 (将棋の慣例)。 */
  promoted?: boolean;
  /** 駒台の駒。 升ではなくボタンの中に収まるサイズ規則を使う。 */
  hand?: boolean;
  className?: string;
}

export function ShogiKoma({ kanji, flipped, promoted, hand, className }: Props) {
  return (
    <span
      className={`shogi-piece ${flipped ? 'flipped' : ''} ${promoted ? 'promoted' : ''} ${
        hand ? 'hand' : ''
      } ${className ?? ''}`}
    >
      <img className="k-wood" src={flipped ? KOMA_OPP : KOMA} alt="" aria-hidden />
      <span className="k-kanji">{kanji}</span>
    </span>
  );
}
